import styled from 'styled-components';

const Close = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  background: #000;
  padding: 2px;
  width: 22px;
  height: 22px;
  text-align: center;
  cursor: pointer;
  ${(props) => props.$styles};
  font-family: ${(props) => props.theme.fonts.sansSerif};
  text-transform: uppercase;
  display: block;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  line-height: 22px;
  z-index: 100;
  span {
    width: 100%;
    height: 100%;
    display: block;
  }
  &:hover {
    color: #000;
    background: #fff;
    border: 1px solid #000;
  }
`;

const CloseBtn = ({ clickEvent, styles }) => (
  <Close onClick={() => clickEvent()} $styles={styles}>
    <span>X</span>
  </Close>
);

export default CloseBtn;
